/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultGeomatique } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_011: Question = {
  id: 'pres-011-plus-grande-parcelle',
  oldId: '25',
  title: 'Taille de la plus grande parcelle non fragmentée',
  number: '2.11',
  description: [''],
  type: QuestionType.INDICATOR,
  frequency: 3,
  slots: [
    {
      type: SlotTypes.GEOMATIQUE,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: true,
      optional: false,
      scoringFct: (data: string[]) => data,
      score: '0',
      help: defaultGeomatique,
      unit: SlotUnit.HECTARE,
    },
  ],
};

// eslint-disable-next-line import/prefer-default-export
export const question_pres_011_v2: Question = question_pres_011;
